import {
  SET_ITEM_COUNT,
  SET_OPTED_IN,
  SET_ENABLE_COMPLIANCE_VARIANT,
  SET_LOYALTY_STATUS
} from "./constants";

export const getLoyaltyStatus = state => state.loyalty;

const initialState = {
  itemCount: null,
  optedIn: false,
  isAvailable: false,
  tierName: null,
  tierNumber: 0,
  enableComplianceVariant: false
};

export const reduce = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_OPTED_IN: {
      return {
        ...state,
        optedIn: payload.optedIn
      };
    }
    case SET_ITEM_COUNT: {
      return {
        ...state,
        itemCount: payload.itemCount
      };
    }
    case SET_ENABLE_COMPLIANCE_VARIANT: {
      return {
        ...state,
        enableComplianceVariant: payload.enableComplianceVariant
      };
    }
    case SET_LOYALTY_STATUS: {
      return {
        ...state,
        isAvailable: payload.isAvailable,
        tierName: payload.tierName,
        tierNumber: payload.tierNumber
      };
    }
    default:
      return state;
  }
};
